// Script for WEBSITE and ADMIN

import React from 'react'
import ReactDOM from 'react-dom'

import Search from '../../components/models/Search'

class KComarquageBlock {
    renderSearchBlock(search) {
        const hearing = search.attributes['data-comarquage-hearing'].value
        ReactDOM.hydrate(<Search hearing={hearing} />, search)
    }
}

const kComarquageBlock = new KComarquageBlock()
const config = { attributes: true, childList: true, subtree: true }

// Create a mutation observer to watch for changes in the DOM
const observer = new MutationObserver((mutationsList, observer) => {
    const searchs = document.querySelectorAll('.baseo_comarquage-search-block')
    for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
            Array.from(searchs).forEach((search) => {
                kComarquageBlock.renderSearchBlock(search)
            })
        } else if (mutation.type === 'attributes') {
            Array.from(searchs).forEach((search) => {
                kComarquageBlock.renderSearchBlock(search)
            })
        }
    }
})

// Start observing the document with the configured parameters
document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, config)
})
